import { FolderOpenTwoTone, FolderTwoTone, HddTwoTone } from '@ant-design/icons'
import React from 'react';
import StatusIcon from '@app/components/common/statusIcon';



export default function getTreeNodeIcon(node, expanded) {
  var _status = node.Status || node.EquipmentStatus || node.MonitorStatus;
  let _color = '';
  if (_status == 'good') {
    _color = '#00cc00';
  } else if (_status == 'warning') {
    _color = 'orange';
  } else if (_status == 'error') {
    _color = 'red';
  } else if (_status == 'disabled') {
    _color = '#aaa';
  }
  if (node.type == 'group') {
    return expanded ? <FolderTwoTone twoToneColor={_color} />
      : <FolderOpenTwoTone twoToneColor={_color} />
    // return <Icon type={expanded ? 'folder-open' : 'folder'} theme="twoTone" twoToneColor={_color} />;
  } else if (node.type == 'monitor') {
    return <StatusIcon status={_status} record={node} />;
  }
  return <HddTwoTone twoToneColor={_color}
  // onMouseDown={(e)=>this.onMouseDownTreeNode(e, node)}
  />;
}